// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentPatientModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentPatientModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentPatientModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentPatientModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentPatientModel.attributeTypeMap = [
    {
        "name": "cellPhone",
        "baseName": "cellPhone",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "string"
    },
    {
        "name": "homePhone",
        "baseName": "homePhone",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "patientContactMethods",
        "baseName": "patientContactMethods",
        "type": ""
    },
    {
        "name": "primaryAddress",
        "baseName": "primaryAddress",
        "type": "CoverMyMedsInboundEnrollmentAddressModel"
    },
    {
        "name": "voicemailConsent",
        "baseName": "voicemailConsent",
        "type": "boolean"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentPatientModel.js.map